import { createContext, useContext } from 'react'

export const defaultLayoutSettings = {
  columnWidth: 60,
  drawHorizontal: false,
  drawHorizontalLines: false,
  drawVertical: true,
  gutterHeight: 12,
  gutterWidth: 20,
  guttersOutside: true,
  horizontalOffset: 0,
  isEnabled: false,
  numberOfColumns: 5,
  numberOfRows: 0,
  rowHeightMultiplication: 5,
  rowWidth: 0,
  totalWidth: 0,
}

export const defaultContextValue = {
  isInspectorEnabled: false,
  isGridEnabled: false,
  toggleGrid: () => {},
  isLayoutEnabled: false,
  toggleLayout: () => {},
  zoomFactor: 1,
  gridSize: 20,
  thickGridTimes: 10,
  layoutSettings: defaultLayoutSettings,
}

interface ArtboardContextValues {
  isInspectorEnabled: boolean
  isGridEnabled: boolean
  toggleGrid: () => void
  isLayoutEnabled: boolean
  toggleLayout: () => void
  zoomFactor: number
  gridSize: number
  thickGridTimes: number
  layoutSettings: {
    columnWidth: number
    drawHorizontal: boolean
    drawHorizontalLines: boolean
    drawVertical: boolean
    gutterHeight: number
    gutterWidth: number
    guttersOutside: boolean
    horizontalOffset: number
    isEnabled: boolean
    numberOfColumns: number
    numberOfRows: number
    rowHeightMultiplication: number
    rowWidth: number
    totalWidth: number
  }
}

export const ArtboardContext = createContext<ArtboardContextValues>(
  defaultContextValue
)

export const useArtboardContext = () => {
  const context = useContext(ArtboardContext)!

  return context
}
